import { render, staticRenderFns } from "./TeamableView.vue?vue&type=template&id=49a28c68&scoped=true"
import script from "./TeamableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamableView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TeamableView.vue?vue&type=style&index=0&id=49a28c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a28c68",
  null
  
)

export default component.exports